import { render, staticRenderFns } from "./UserContractOrderList.vue?vue&type=template&id=ba5b61a8&"
import script from "./UserContractOrderList.vue?vue&type=script&lang=js&"
export * from "./UserContractOrderList.vue?vue&type=script&lang=js&"
import style0 from "./UserContractOrderList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports